const ingredientsData = [
  {
    name: "Amaro Montenegro",
    abv: "23",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Amaro Nonino Quintessentia",
    abv: "35",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Amarula Cream Liqueur",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Ancho Reyes Ancho Chile Liqueur",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Aperol",
    abv: "11",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Averna Amaro",
    abv: "32",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Baileys Irish Cream Original",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Becherovka",
    abv: "38",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "BÉNÉDICTINE D.O.M. Liqueur",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Braulio Amaro",
    abv: "21",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Campari",
    abv: "24",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cardamaro Vino Amaro",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Chartreuse Yellow Liqueur",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cherry Heering Liqueur",
    abv: "24",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cointreau",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cynar",
    abv: "16.5",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Dekuyper Triple Sec Liqueur",
    abv: "24",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Disaronno Originale Amaretto",
    abv: "28",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Domaine De Canton Ginger Liqueur",
    abv: "28",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Drambuie The Isle of Skye Scotch Liqueur",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Fernet-Branca",
    abv: "39",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Galliano L’Autentico",
    abv: "42.3",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Giffard Creme de Violette",
    abv: "16",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Grand Marnier Cordon Rouge",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Green Chartreuse ",
    abv: "55",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Hiram Walker Triple Sec 30 Proof",
    abv: "15",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Jägermeister",
    abv: "35",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Jeppson’s Malort",
    abv: "35",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Kahlúa",
    abv: "21",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Licor 43",
    abv: "31",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Luxardo Maraschino Liqueur",
    abv: "32",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Mathilde Cassis",
    abv: "16",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Midori Melon Liqueur",
    abv: "20",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Mr. Black Cold Brew Coffee Liqueur",
    abv: "25",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "PAMA Pomegranate Liqueur",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Pernod Anise Liqueur (Pastis)",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Pierre Ferrand Dry Curacao",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Pimm’s No. 1 Cup",
    abv: "25",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Ramazzotti Amaro",
    abv: "30",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Ricard Pastis De Marseille",
    abv: "45",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Romana Sambuca",
    abv: "42",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Rothman & Winter Creme de Violette",
    abv: "20",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Select Aperitivo",
    abv: "17.5",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "St-Germain Elderflower Liqueur",
    abv: "20",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "St. Elizabeth Allspice Dram",
    abv: "22.5",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Suze Saveur d’Autrefois",
    abv: "20",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Alto del Carmen Pisco Reservado",
    abv: "40",
    category: "brandy",
    hex: "D66014",
  },
  {
    name: "Courvoisier VS Cognac",
    abv: "40",
    category: "brandy",
    hex: "D66014",
  },
  {
    name: "E&J VSOP Premium Brandy",
    abv: "40",
    category: "brandy",
    hex: "D66014",
  },
  {
    name: "Hennessy VS Cognac",
    abv: "40",
    category: "brandy",
    hex: "D66014",
  },
  {
    name: "Laird's Straight Apple Brandy (Bottled in Bond)",
    abv: "50",
    category: "brandy",
    hex: "D66014",
  },
  {
    name: "Laird’s Applejack",
    abv: "40",
    category: "brandy",
    hex: "D66014",
  },
  {
    name: "Lairds Straight Applejack 86",
    abv: "43",
    category: "brandy",
    hex: "D66014",
  },
  {
    name: "Rémy Martin VSOP",
    abv: "40",
    category: "brandy",
    hex: "D66014",
  },
  {
    name: "Aviation Gin",
    abv: "42",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Barr Hill Gin",
    abv: "45",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Beefeater London Dry Gin",
    abv: "44",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Bluecoat Gin",
    abv: "47",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Bols Genever Original Gin",
    abv: "42",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Bombay Original Dry Gin",
    abv: "43",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Bombay Sapphire East Gin",
    abv: "42",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Bombay Sapphire Gin",
    abv: "47",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Boodles Gin",
    abv: "45.2",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Brokers Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Brooklyn Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Bulldog London Dry Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Citadelle Gin",
    abv: "44",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Damrak Gin",
    abv: "41.8",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Death’s Door Gin",
    abv: "47",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Dorothy Parker American Gin",
    abv: "44",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Drumshanbo Gunpowder Irish Gin",
    abv: "43",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Farmer’s Organic Gin",
    abv: "46.7",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Fords Gin",
    abv: "45",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Gilbey’s London Dry Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Gin Mare",
    abv: "42.7",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Glendalough Wild Botanical Gin",
    abv: "41",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Gordon’s London Dry Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Gray Whale Gin",
    abv: "43",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Greenhook Ginsmiths American Dry Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Hendrick’s Gin",
    abv: "44",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Junipero Gin",
    abv: "49.3",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "King’s Ginger Liqueur",
    abv: "41",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "KOVAL Dry Gin",
    abv: "47",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Leopold's American Small Batch Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Leopold's Summer Gin",
    abv: "47",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Letherbee Original Label Gin",
    abv: "48",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Malfy Gin Con Limone",
    abv: "41",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Monkey 47 Dry Gin",
    abv: "47",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "New Amsterdam Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "No. 3 London Dry Gin",
    abv: "46",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "NOLET’S Silver Gin",
    abv: "47.6",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Perry’s Tot Navy Strength Gin",
    abv: "57",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Plymouth Gin",
    abv: "41.2",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Plymouth Navy Strength Gin",
    abv: "57",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Prairie Organic Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Roku Japanese Gin",
    abv: "43",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Salcombe Gin ‘Start Point’",
    abv: "44",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Seagram’s Extra Dry Gin",
    abv: "40",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Sipsmith London Dry Gin",
    abv: "41.6",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Sipsmith V.J.O.P. Gin",
    abv: "57.7",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Spring44 Gin",
    abv: "44",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "St. George Botanivore Gin",
    abv: "45",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "St. George Terrior Gin",
    abv: "45",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Tanqueray London Dry Gin",
    abv: "47.3",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Tanqueray No. Ten Gin",
    abv: "47.3",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "The Botanist Islay Dry Gin",
    abv: "46",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Uncle Val’s Gin Botanical Gin",
    abv: "45",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Vikre Boreal Spruce Gin",
    abv: "45",
    category: "gin",
    hex: "F1F2F2",
  },
  {
    name: "Alipus Santa Ana del Rio Mezcal",
    abv: "47.9",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Banhez Mezcal",
    abv: "42",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Bozal Ensamble Mezcal",
    abv: "47",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Del Maguey Chichicapa Mezcal",
    abv: "46",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Del Maguey Vida Mezcal",
    abv: "42",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Dos Hombres Joven Mezcal",
    abv: "42",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "El Buho Mezcal",
    abv: "45",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Fidencio Mezcal",
    abv: "40",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Gracias A Dios Espadín Mezcal",
    abv: "45",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Ilegal Mezcal Joven",
    abv: "40",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "La Venenosa Raicilla Sierra de Jalisco",
    abv: "42",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Madre Mezcal",
    abv: "45",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mal Bien Espadin Mezcal",
    abv: "45.5",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mayalen Wild Cupreata Mezcal",
    abv: "48",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcal Amaras Espadin",
    abv: "41",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcal El Silencio Ensamble",
    abv: "40",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcal El Silencio Espadin",
    abv: "43",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcal Real Minero Barril Artesanal",
    abv: "50.65",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcal Union El Viejo",
    abv: "45",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcal Union Uno",
    abv: "40",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcal Vago Elote",
    abv: "50.1",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcal Vago Espadin",
    abv: "50.1",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Mezcales de Leyenda Guerrero",
    abv: "45",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Montelobos Mezcal Joven",
    abv: "43.2",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Nuestra Soledad San Baltazar Mezcal",
    abv: "48",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Nuestra Soledad San Luis del Rio Mezcal",
    abv: "48",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Peloton De La Muerte Espadin Mezcal",
    abv: "41",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Rosaluna Artesanal Mezcal Joven (Espadín)",
    abv: "40",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Siete Misterios Doba-Yej Mezcal",
    abv: "45.5",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Sombra Mezcal",
    abv: "45",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Yola Mezcal",
    abv: "45",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Yuu Baal Espadin Joven Mezcal",
    abv: "48",
    category: "mezcal",
    hex: "A9C2B0",
  },
  {
    name: "Angostura 5 Year Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Appleton Estate 12 Year Rare Blend",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Appleton Estate 8 Year Old Reserve",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Appleton Estate Reserve Blend Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Appleton Estate Signature Blend Jamaica Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "BACARDÍ 151",
    abv: "75.5",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "BACARDÍ Anejo Cuatro Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "BACARDÍ Gold Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "BACARDÍ Reserva Ocho Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "BACARDÍ Select",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "BACARDÍ Superior White Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Brugal 1888 Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Brugal Añejo Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Brugal Extra Dry Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Brugal Extra Viejo Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Brugal XV Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Captain Morgan 100 Proof Spiced Rum",
    abv: "50",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Captain Morgan Original Spiced Rum",
    abv: "35",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Coruba Dark Jamaican Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Cruzan 151 Proof Rum",
    abv: "75.5",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Cruzan Aged Dark Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Cruzan Aged Light Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Cruzan Black Strap Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Diplomatico Planas Rum",
    abv: "47",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Diplomatico Rum Reserva Exclusiva",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Don Papa Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Don Q 151 Rum",
    abv: "75.5",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Don Q Rum Cristal",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "El Dorado 12 Year Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "El Dorado 21 Year Rum",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "El Dorado Rum 15 Year",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Flor de Caña 12 Year Old Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Flor de Caña 18 Year Old Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Flor de Caña 4 Year Old Gold Rum Añejo Oro",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Goslings Black Seal 151 Proof Rum",
    abv: "75.5",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Goslings Black Seal Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Malibu Original Caribbean Rum",
    abv: "21",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Mount Gay Rum Black Barrel",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Mount Gay Rum Eclipse",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Myers’s Original Dark Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Old Monk Rum 7 Year",
    abv: "42.5",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Plantation 3 Stars White Rum",
    abv: "41.2",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Plantation Barbados 5 Year Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Plantation Dark Overproof O.F.T.D. Rum",
    abv: "69",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Plantation Original Dark Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Plantation Stiggins’ Fancy Pineapple Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Pusser’s British Navy Rum",
    abv: "42",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Pyrat Rum XO Reserve",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Real McCoy Barbados Rum 3 Year",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Rhum Barbancourt 4 Year 3 Star",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Rhum Barbancourt 5 Star 8 Year Rum",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Rhum Barbancourt Estate Reserve 15 Year",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Rhum Barbancourt Réserve Spéciale 8 Year",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Rhum Barbancourt White Rum",
    abv: "43",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Ron Abuelo Rum Anejo",
    abv: "35",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Ron Zacapa 23 Year Centenario Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Sailor Jerry Spiced Rum",
    abv: "46",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Santa Teresa 1796 Solera Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Smith & Cross Navy Rum",
    abv: "57",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "The Kraken Black Spiced Rum",
    abv: "47",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "The Kraken Black Spiced Rum 70 Proof",
    abv: "35",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Wray & Nephew White Overproof Rum",
    abv: "63",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Zaya Gran Reserva 12 Year Rum",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: " Casamigos Anejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: " Casamigos Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "123 Organic Blanco Tequila (Uno)",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "1800 Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "1800 Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Arette Blanco Tequila",
    abv: "38",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Arette Suave Artesanal Blanco Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Camarena Reposado",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Camarena Silver",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Casa Noble Crystal Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Casa Noble Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Casamigos Blanco Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Cazadores Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Cimarron Blanco Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Clase Azul Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Código 1530 Anejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Corralejo Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Corralejo Tequila Blanco",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Don Julio Anejo",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Don Julio Blanco Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Don Julio Reposado",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "El Jimador Anejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "El Jimador Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "El Jimador Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "El Luchador Organic Tequila",
    abv: "55",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "El Tesoro Anejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "El Tesoro Blanco Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "El Tesoro Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Espolòn Tequila Blanco",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Espolòn Tequila Reposado",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Fortaleza Tequila Blanco",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Gran Centenario Anejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Gran Centenario Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Herradura Anejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Herradura Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Herradura Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Hornitos Plata Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Hornitos Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "JAJA Blanco Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "JAJA Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Jose Cuervo Especial Gold",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Jose Cuervo Especial Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Jose Cuervo Tradicional Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Jose Cuervo Tradicional Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "La Gritona Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Lunazul Blanco Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Lunazul Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Milagro Anejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Milagro Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Milagro Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Olmeca Altos Anejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Olmeca Altos Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Olmeca Altos Tequila Plata",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Patrón Añejo Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Patrón Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Patrón Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Pueblo Viejo 104 Blanco Tequila",
    abv: "52",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Sauza Gold Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Sauza Signature Blue Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Sauza Silver Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Siete Leguas Tequila Blanco",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Tapatio Blanco 110 Tequila",
    abv: "55",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Tapatio Tequila Blanco",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Tequila Avión Silver",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Tequila Casa Dragones Blanco",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Tequila Ocho Plata",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Tequila Ocho Reposado",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Tequila Partida Añejo",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Teremana Reposado Tequila",
    abv: "40",
    category: "tequila",
    hex: "D6EDC7",
  },
  {
    name: "Absolut Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Belvedere Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Finlandia Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "GREY GOOSE Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Ketel One Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Monopolowa Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "New Amsterdam Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Reyka Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "SKYY Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Smirnoff No. 21 Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Stolichnaya Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "SVEDKA Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Tito’s Handmade Vodka",
    abv: "40",
    category: "vodka",
    hex: "F1F2F2",
  },
  {
    name: "Angel's Envy Kentucky Straight Bourbon Whiskey",
    abv: "43.3",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Angel's Envy Rum Cask Rye",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Ardbeg Wee Beastie",
    abv: "47.4",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Basil Hayden's Kentucky Straight Bourbon Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Basil Hayden’s Rye Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Blanton's Single Barrel Bourbon Whiskey",
    abv: "46.5",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Buchanan's 12-Year Blended Scotch",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Buffalo Trace Bourbon Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Bulleit Bourbon Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Bulleit Rye Aged 12 Years Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Bulleit Rye Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Canadian Club Whisky",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Catoctin Creek Roundstone Rye 80 Proof",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Compass Box Great King Street Artist's Blend",
    abv: "43",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Crown Royal Canadian Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Cutty Sark Prohibition Blended Scotch",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Dewar’s 12 Year Blended Scotch Whisky",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Dewar’s White Label Blended Scotch Whisky",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Eagle Rare 10-Year Bourbon Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Egan's Vintage Grain Single Malt Irish Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Elijah Craig Barrel Proof Bourbon Whiskey",
    abv: "63.62",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Elijah Craig Small Batch Bourbon Whiskey",
    abv: "47",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Evan Williams Bottled-in-Bond Bourbon Whiskey (White Label)",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Evan Williams Kentucky Straight Bourbon Whiskey (Black Label) ",
    abv: "43",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Evan Williams Single Barrel Bourbon Whiskey",
    abv: "43.3",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Famous Grouse Smoky Black",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Four Roses Bourbon Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Four Roses Single Barrel Bourbon Whiskey",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Four Roses Small Batch Bourbon Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "George Dickel No. 8 Tennessee Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "George Dickel Rye Whisky",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Green Spot Irish Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Henry McKenna Single Barrel Bourbon 10-Year, Bottled-in-Bond",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "High West American Prairie Bourbon Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "High West Double Rye Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "High West Rendezvous Rye Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Hudson Manhattan Rye Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "J&B Rare Blended Scotch",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Jack Daniel's Old No. 7 Tennessee Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Jack Daniel’s Gentleman Jack Tennessee Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Jack Daniel’s Rye Tennessee Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Jack Daniel’s Single Barrel Select Tennessee Whiskey",
    abv: "47",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "James E. Pepper 1776 Straight Rye Whiskey",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Jim Beam Black Extra Aged Bourbon Whiskey",
    abv: "43",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Jim Beam Bourbon Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Jim Beam Rye Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Johnnie Walker Red Label Blended Scotch Whisky",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Knob Creek Kentucky Straight Bourbon Whiskey",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Laphroaig 10 Year Old Islay Single Malt Scotch Whisky",
    abv: "43",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Larceny Small Batch Bourbon Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Maker's 46 Bourbon Whiskey",
    abv: "47",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Maker's Mark Bourbon Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Michter's US-1 Kentucky Straight Bourbon Whiskey",
    abv: "45.7",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Michter’s US-1 Kentucky Straight Rye",
    abv: "42.4",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Monkey Shoulder Blended Scotch Whisky",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Nikka Coffey Grain Whisky",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Noah's Mill Bourbon Whiskey",
    abv: "57.15",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Old Bardstown Estate 101 Proof Kentucky Straight Bourbon Whiskey",
    abv: "50.5",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Old Forester 100-Proof Signature Bourbon Whiskey",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Old Forester 86 Proof Kentucky Straight Bourbon Whiskey",
    abv: "43",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Old Grand Dad Bonded Bourbon Whiskey",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Old Overholt Bonded Rye Whiskey",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Old Overholt Rye Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Pig's Nose Blended Scotch Whisky",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Pikesville Rye Whiskey",
    abv: "55",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Redemption Rye Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Rittenhouse Rye Whiskey",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Russell’s Reserve 6 Year Old Rye",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Sagamore Spirit Signature Rye Whiskey",
    abv: "41.5",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Sazerac Rye Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Seagram’s 7 Crown Blended Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Sheep Dip Scotch Whisky",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Southern Comfort Original",
    abv: "35",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Stranahan’s Colorado Whiskey",
    abv: "47",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Teeling Small Batch Irish Whiskey",
    abv: "46",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Templeton Rye 6 Year Whiskey",
    abv: "45.75",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "The Glenlivet 12 Year Single Malt Scotch Whisky",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "",
    abv: "",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "TINCUP American Whiskey",
    abv: "42",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "TINCUP Straight Rye Whiskey",
    abv: "45",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Tullamore D.E.W. Irish Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Uncle Nearest 1856 Premium Whiskey",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Uncle Nearest 1884 Small Batch Whiskey",
    abv: "46.5",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Weller Special Reserve Bourbon Whiskey",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "WhistlePig Rye Whiskey 10 Year",
    abv: "50",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Wild Turkey 101 Bourbon Whiskey",
    abv: "50.5",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Wild Turkey 101 Rye",
    abv: "50.5",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Wild Turkey Kentucky Straight Bourbon Whiskey (81 proof)",
    abv: "40.5",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Wild Turkey Rare Breed Barrel Proof Rye",
    abv: "56.1",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Wild Turkey Rye",
    abv: "40.5",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Willett Family Estate Bottled Rye 4 Year",
    abv: "55",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Woodford Reserve Kentucky Straight Bourbon Whiskey",
    abv: "45.2",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Woodford Reserve Kentucky Straight Rye Whiskey",
    abv: "45.2",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Jameson Irish Whiskey",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "Johnnie Walker Black Label Blended Scotch Whisky ",
    abv: "40",
    category: "whiskey",
    hex: "9E4200",
  },
  {
    name: "St. George Absinthe Verte",
    abv: "60",
    category: "absinthe",
    hex: "859e75",
  },
  {
    name: "Tenneyson Absinthe Royale",
    abv: "53",
    category: "absinthe",
    hex: "859e75",
  },
  {
    name: "Vieux Pontarlier Absinthe",
    abv: "65",
    category: "absinthe",
    hex: "859e75",
  },
  {
    name: "Dolin Dry Vermouth de Chambery",
    abv: "17",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Carpano Antica Formula Vermouth",
    abv: "16.5",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Cocchi Vermouth di Torino",
    abv: "16",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Dolin Rouge Vermouth de Chambery",
    abv: "16",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Carpano Punt e Mes",
    abv: "16",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Dolin Blanc Vermouth de Chambery",
    abv: "16",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Lustau Red Vermut",
    abv: "15",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Martini & Rossi Sweet Vermouth",
    abv: "15",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Cinzano Sweet Vermouth",
    abv: "15",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Noilly Prat Extra Dry Vermouth",
    abv: "18",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Martini & Rossi Extra Dry Vermouth",
    abv: "15",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Noilly Prat Sweet Vermouth",
    abv: "16",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Lustau Blanco Vermut",
    abv: "15",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Carpano Bianco Vermouth",
    abv: "14.9",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Cinzano Extra Dry Vermouth",
    abv: "18",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Del Professore White Vermouth",
    abv: "18",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "La Quintinye Blanc Royal Vermouth",
    abv: "16",
    category: "vermouth",
    hex: "891576",
  },
  {
    name: "Italicus Bergamot Liqueur",
    abv: "20",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Lillet Blanc",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cocchi Americano Aperitif",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Faccia Brutto Aperitivo Liqueur",
    abv: "24",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cappelletti Aperitivo Americano Rosso",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Dolin Genepy Le Chamois",
    abv: "45",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cocchi Americano Rosa",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Forthave Spirits Red Aperitivo",
    abv: "24",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Galliano",
    abv: "42",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "L.N. Mattei Cap Corse Blanc Aperitif",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Lillet Rouge",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Lillet Rosé",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Salers Aperitif",
    abv: "16",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "St. Agrestis Inferno Bitter Liqueur",
    abv: "24",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Tempus Fugit Gran Classico Bitter",
    abv: "28",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Tempus Fugit Kina L'Aero",
    abv: "27",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Amaro Nonino",
    abv: "35",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Amaro Meletti",
    abv: "32",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Braulio Amaro",
    abv: "21",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cappelletti Amaro Sfumato Rabarbaro",
    abv: "20",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Bigallet China China Amer Bitter Liqueur",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cardamaro",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Zucca Rabarbaro Amaro",
    abv: "34",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Grand Marnier",
    abv: "40",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Ramazzotti Amaro",
    abv: "31",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Amaro Nardini",
    abv: "31",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Cocchi Barolo Chinato",
    abv: "17",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Club Soda",
    abv: "0",
    category: "Nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Seltzer",
    abv: "0",
    category: "Nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Lemon juice",
    abv: "0",
    category: "Nonalcoholic",
    hex: "F0DA89",
  },
  {
    name: "Lime juice",
    abv: "0",
    category: "Nonalcoholic",
    hex: "A7CE95",
  },
  {
    name: "Orange juice",
    abv: "0",
    category: "Nonalcoholic",
    hex: "EBB76D",
  },
  {
    name: "Peach purée",
    abv: "0",
    category: "Nonalcoholic",
    hex: "FFBEA9",
  },
  {
    name: "Cranberry juice",
    abv: "0",
    category: "Nonalcoholic",
    hex: "D54333",
  },
  {
    name: "Tonic water",
    abv: "0",
    category: "Nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Cola",
    abv: "0",
    category: "Nonalcoholic",
    hex: "F2CFA4",
  },
  {
    name: "Ginger ale",
    abv: "0",
    category: "Nonalcoholic",
    hex: "F2CFA4",
  },
  {
    name: "Ginger beer (commercial)",
    abv: "0",
    category: "Nonalcoholic",
    hex: "F2CFA4",
  },
  {
    name: "Grapefruit soda",
    abv: "0",
    category: "Nonalcoholic",
    hex: "E5B0B6",
  },
  {
    name: "Novo Fogo Tanager Cachaça",
    abv: "42",
    category: "Cachaça",
    hex: "7DBFD3",
  },
  {
    name: "Avuá Cachaça Amburana",
    abv: "40",
    category: "Cachaça",
    hex: "7DBFD3",
  },
  {
    name: "Avuá Prata Cachaça",
    abv: "42",
    category: "Cachaça",
    hex: "7DBFD3",
  },
  {
    name: "Leblon Cachaça",
    abv: "40",
    category: "Cachaça",
    hex: "7DBFD3",
  },
  {
    name: "Yaguara Cachaça Branca",
    abv: "40.5",
    category: "Cachaça",
    hex: "7DBFD3",
  },
  {
    name: "Macchu Pisco La Diablada Pisco",
    abv: "40",
    category: "Pisco",
    hex: "7DAA8A",
  },
  {
    name: "Pisco 1615 Puro Quebranta Pisco",
    abv: "42",
    category: "Pisco",
    hex: "7DAA8A",
  },
  {
    name: "Macchu Pisco",
    abv: "40",
    category: "Pisco",
    hex: "7DAA8A",
  },
  {
    name: "Barsol Pisco Primero Quebranta",
    abv: "40",
    category: "Pisco",
    hex: "7DAA8A",
  },
  {
    name: "Campo de Encanto Pisco Acholado",
    abv: "42",
    category: "Pisco",
    hex: "7DAA8A",
  },
  {
    name: "Pisco Porton",
    abv: "43",
    category: "Pisco",
    hex: "7DAA8A",
  },
  {
    name: "Boukman Botanical Haitian Rhum",
    abv: "45",
    category: "Rum",
    hex: "9E4200",
  },
  {
    name: "Boukman Botanical Haitian Rhum",
    abv: "45",
    category: "Rum",
    hex: "9E4200",
  },
  {
    name: "Clairin Casimir Haitian Rum",
    abv: "48.3",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Christian Drouin Calvados Selection",
    abv: "40",
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Pierre Ferrand 1840 Formula Cognac",
    abv: "45",
    category: "cognac",
    hex: "D66014",
  },
  {
    name: "Pierre Ferrand Cognac Ambre",
    abv: "40",
    category: "cognac",
    hex: "D66014",
  },
  {
    name: "Grapefruit juice",
    abv: "0",
    category: "nonalcoholic",
    hex: "E5B0B6",
  },
  {
    name: "La Marca Prosecco",
    abv: "11.2",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Ruffino Prosecco",
    abv: "11",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Mionetto Prosecco Brut",
    abv: "11",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Nino Franco Rustico Prosecco Superiore",
    abv: "11",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Jaume Serra Cristalino Cava Brut",
    abv: "11.5",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Segura Viudas Cava Brut",
    abv: "12",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Roederer Estate Brut Sparkling Wine",
    abv: "12.5",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Bisson Glera Frizzante Prosecco",
    abv: "11",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Valdo Marca Oro Prosecco",
    abv: "11",
    category: "sparkling wine",
    hex: "F5E29D",
  },
  {
    name: "Coffee or espresso",
    abv: "0",
    category: "nonalcoholic",
    hex: "742C0D",
  },
  {
    name: "Cream",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Cream of coconut",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Coconut milk",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "El Maestro Sierra, Fino Sherry",
    abv: "15",
    category: "Sherry",
    hex: "CC5747",
  },
  {
    name: 'Gonzalez-Byass "Tio Pepe" Fino Sherry',
    abv: "15",
    category: "Sherry",
    hex: "CC5747",
  },
  {
    name: 'Bodegas Valdespino - "Inocente" Fino Sherry',
    abv: "15",
    category: "Sherry",
    hex: "CC5747",
  },
  {
    name: 'Hidalgo la Gitana Amontillado "Napoleon" Sherry',
    abv: "17.5",
    category: "Sherry",
    hex: "CC5747",
  },
  {
    name: 'Lustau Dry Amontillado "Los Arcos" Sherry',
    abv: "18.5",
    category: "Sherry",
    hex: "CC5747",
  },
  {
    name: "Lustau East India Solera Sherry",
    abv: "20",
    category: "Sherry",
    hex: "CC5747",
  },
  {
    name: 'Lustau Palo Cortado "Peninsula" Sherry',
    abv: "19",
    category: "Sherry",
    hex: "CC5747",
  },
  {
    name: 'Lustau Pedro Ximenez "San Emilio" Sherry',
    abv: "17",
    category: "Sherry",
    hex: "CC5747",
  },
  {
    name: "Tempus Fugit Crème de Cacao ",
    abv: "24",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Giffard Banane du Bresil ",
    abv: "25",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Egg white",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Simple syrup",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Cherry Heering",
    abv: "24",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Ozeki Dry Saké, Junmai",
    abv: "14.5",
    category: "sake",
    hex: "A5B7BD",
  },
  {
    name: "Gekkeikan Sake",
    abv: "15.6",
    category: "sake",
    hex: "A5B7BD",
  },
  {
    name: "Fukucho Moon on the Water Junmai Ginjo Sake",
    abv: "16.5",
    category: "sake",
    hex: "A5B7BD",
  },
  {
    name: 'Chiyonosono Shuzo "Shared Promise" Junmai Sake ',
    abv: "15",
    category: "sake",
    hex: "A5B7BD",
  },
  {
    name: "Orgeat ",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "John D. Taylor's Velvet Falernum",
    abv: "11",
    category: "amaro, liqueur, aperitif",
    hex: "F57C7C",
  },
  {
    name: "Angostura Bitters",
    abv: "44.7",
    category: "bitters",
    hex: "AD0E0E",
  },
  {
    name: "Peychaud's Bitters",
    abv: "35",
    category: "bitters",
    hex: "AD0E0E",
  },
  {
    name: "Regan's Orange Bitters",
    abv: "45",
    category: "bitters",
    hex: "AD0E0E",
  },
  {
    name: "El Dorado 3 Year Old Rum",
    abv: 40,
    category: "rum",
    hex: "9E4200",
  },
  {
    name: "Rose's Sweetened Lime Juice",
    abv: 0,
    category: "nonalcoholic",
    hex: "A7CE95",
  },
  {
    name: "Agave syrup",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Honey syrup",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Grenadine",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
  {
    name: "Raspberry syrup",
    abv: "0",
    category: "nonalcoholic",
    hex: "D0E7EE",
  },
]

export default ingredientsData
